import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TnrAuthProviderService } from '@tnr/ng-oauth2';

@Component({
  selector: 'app-oidc-callback',
  template: `
    <div class="h-100 mh-100 d-flex flex-column justify-content-center align-items-center">
      <p class="text-lg text-gray-600 m-0">Signing in...</p>
    </div>
  `
})
export class OidcCallbackComponent implements OnInit {
  constructor(
    private readonly authProviderService: TnrAuthProviderService,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      await this.authProviderService.runInitialLoginSequence();
      this.router.navigate(['/']);
    } catch (error) {
      // Optionally handle error, e.g., show a message or redirect
      this.router.navigate(['/']);
    }
  }
}
